import { Routes } from '@angular/router';
import { Login } from './login/login';
import { ForgotPassword } from './forgot-password/forgot-password';
import { ChangePassword } from './change-password/change-password';
import { EmulateAgent } from './emulate-agent/emulate-agent';

export const publicRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  { path: 'login', component: Login },
  { path: 'forgot-password', component: ForgotPassword },
  { path: 'change-password/:allyId/:userType/:username', component: ChangePassword },
  { path: 'emulate', component: EmulateAgent },
  // { path: '**', redirectTo: 'login' }, // Default to login
];
